import styled from "styled-components";

interface IProps {
  splashScreenUrl: string;
}

const KiosModeSplashScreen = styled.div`
  width: 100vw;
  height: 100vh;
  ${({ splashScreenUrl }: IProps) => `background: url(${splashScreenUrl});`};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

export default KiosModeSplashScreen;



// WEBPACK FOOTER //
// ./src/components/Splash/KiosModeSplashScreen.tsx